/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/warenkorb-action-info/shop.warenkorb-action-info.component.ts.
 */
import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {WarenkorbActionInfo} from '../../../../models/warenkorb-action-info';

/**
 * Zweck: Beschreibt class ShopWarenkorbActionInfoComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-shop-warenkorb-action-info',
    templateUrl: 'shop.warenkorb-action-info.component.html',
    styleUrls: ['shop.warenkorb-action-info.component.scss'],
    standalone: false
})
export class ShopWarenkorbActionInfoComponent {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: WarenkorbActionInfo) {

  }

/**
 * Beschreibt Methode keydown und ihren Rückgabevertrag.
 */
  keydown(event) {
    event.stopPropagation();
  }
}
